import { useEffect, useState } from "react";

export function useNetworkState() {
  const [networkState, setNetworkState] = useState({
    isOnline: navigator.onLine,
    effectiveType:
      navigator.connection && navigator.connection.effectiveType
  });

  const updateNetworkStatus = () => {
    setNetworkState({
      isOnline: navigator.onLine,
      effectiveType:
        (navigator.connection && navigator.connection.effectiveType) || "",
    });
  };

  useEffect(() => {
    updateNetworkStatus();

    window.addEventListener("online", updateNetworkStatus);
    window.addEventListener("offline", updateNetworkStatus);

    if (navigator.connection) {
      navigator.connection.addEventListener("change", updateNetworkStatus);
    }

    return () => {
      window.removeEventListener("online", updateNetworkStatus);
      window.removeEventListener("offline", updateNetworkStatus);

      if (navigator.connection) {
        navigator.connection.removeEventListener(
          "change",
          updateNetworkStatus
        );
      }
    };
  }, []);

  return networkState;
}

